const fullgrid = {
    numColumns: 4,
    numRows: 2,
    // used for view more feature, view more starts on this slide
    slidesCovered: 5,
    moreSize: 12,
    borderWidth: 15,
    extraRows: 0,
    cellInstances: null,
    cells: {
        // image order as returned are keys
        1: {
            imageNum:0,
            col: 0,
            row: 0,
            size: 2,
            class: 'featured featured-1',
        },
        2: {
            imageNum: 1,
            col: 2,
            row: 0,
            size: 1,
        },
        3: {
            imageNum: 2,
            col: 3,
            row: 0,
            size: 1,
        },
        4: {
            imageNum: 3,
            col: 2,
            row: 1,
            size: 1,
        },
        5: {
            imageNum: 4,
            col: 3,
            row: 1,
            size: 1,
        },
    }
}

export default fullgrid;
